export class ToggleSelectedUser {
    static readonly type = '[User] ToggleSelectedUser';

    constructor(public payload: string) {}
}
